import { render, staticRenderFns } from "./EditDestination.vue?vue&type=template&id=118dea8c&scoped=true"
import script from "./EditDestination.vue?vue&type=script&lang=js"
export * from "./EditDestination.vue?vue&type=script&lang=js"
import style0 from "./EditDestination.vue?vue&type=style&index=0&id=118dea8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118dea8c",
  null
  
)

export default component.exports